export enum AreaType {
  SELECT = 'SELECT',
  URBAN = 'URBAN',
  RURAL = 'RURAL',
}

export const convertAreaType = (areaType: AreaType): string => {
  let word = '';
  switch (areaType) {
    case AreaType.SELECT:
      word = 'Selecione uma Opção';
      break;
    case AreaType.URBAN:
      word = 'Urbano';
      break;
    case AreaType.RURAL:
      word = 'Rural';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ArtRrt {
  SELECT = 'SELECT',
  STANDARD = 'STANDARD',
  EXCLUSIVE = 'EXCLUSIVE',
}

export const convertArtRrt = (artRrt: ArtRrt): string => {
  let word = '';
  switch (artRrt) {
    case ArtRrt.SELECT:
      word = 'Selecione uma Opção';
      break;
    case ArtRrt.STANDARD:
      word = 'Padrão';
      break;
    case ArtRrt.EXCLUSIVE:
      word = 'Exclusivo';
      break;
    default:
      word = '';
  }
  return word;
};

export enum DeedStatus {
  SELECT = 'SELECT',
  UPLOAD = 'UPLOAD',
  NUMBER_ONLY = 'NUMBER_ONLY',
  NONE = 'NONE',
}

export const convertDeedStatus = (deedStatus: DeedStatus): string => {
  let word = '';
  switch (deedStatus) {
    case DeedStatus.SELECT:
      word = 'Selecione uma Opção';
      break;
    case DeedStatus.UPLOAD:
      word = 'Arquivo anexado';
      break;
    case DeedStatus.NUMBER_ONLY:
      word = 'Apenas número informado';
      break;
    case DeedStatus.NONE:
      word = 'Sem matrícula';
      break;
    default:
      word = '';
  }
  return word;
};

export enum DocumentSource {
  EXTERNAL = 'external',
  REVIEWER = 'reviewer',
}

export enum PreFlightDocumentType {
  SELECT = 'SELECT',
  DEED = 'DEED',
  IPTU = 'IPTU',
  BLUEPRINT = 'BLUEPRINT',
  HABITE_SE = 'HABITE_SE',
  CONDOMINIUM_CONVENTION = 'CONDOMINIUM_CONVENTION',
  CONTRACT = 'CONTRACT',
  PHOTOS = 'PHOTOS',
  OTHER = 'OTHER',
}

export const convertDocumentType = (
  documentType: PreFlightDocumentType
): string => {
  let word = '';
  switch (documentType) {
    case PreFlightDocumentType.SELECT:
      word = 'Selecione uma Opção';
      break;
    case PreFlightDocumentType.DEED:
      word = 'Matrícula';
      break;
    case PreFlightDocumentType.IPTU:
      word = 'IPTU';
      break;
    case PreFlightDocumentType.BLUEPRINT:
      word = 'Planta';
      break;
    case PreFlightDocumentType.HABITE_SE:
      word = 'Habite-se';
      break;
    case PreFlightDocumentType.CONDOMINIUM_CONVENTION:
      word = 'Convenção de Condomínio';
      break;
    case PreFlightDocumentType.CONTRACT:
      word = 'Contrato';
      break;
    case PreFlightDocumentType.PHOTOS:
      word = 'Fotos';
      break;
    case PreFlightDocumentType.OTHER:
      word = 'Outros';
      break;
    default:
      word = '';
  }
  return word;
};

export enum Method {
  SELECT = 'SELECT',
  MCDDM_INFERENCE = 'MCDDM_INFERENCE',
  MCDDM_FACTORS = 'MCDDM_FACTORS',
  EVOLUTIVE = 'EVOLUTIVE',
  INVOLUTIVE = 'INVOLUTIVE',
  INCOME_CAPITALIZATION = 'INCOME_CAPITALIZATION',
}

export const convertMethod = (method: Method): string => {
  let word = '';
  switch (method) {
    case Method.SELECT:
      word = 'Selecione uma Opção';
      break;
    case Method.MCDDM_INFERENCE:
      word = 'MCDDM — Inferência Estatística';
      break;
    case Method.MCDDM_FACTORS:
      word = 'MCDDM — Fatores';
      break;
    case Method.EVOLUTIVE:
      word = 'Evolutivo';
      break;
    case Method.INVOLUTIVE:
      word = 'Involutivo';
      break;
    case Method.INCOME_CAPITALIZATION:
      word = 'Capitalização da Renda';
      break;
    default:
      word = '';
  }
  return word;
};

export enum Modality {
  SELECT = 'SELECT',
  AVM = 'AVM',
  AI_ASSISTED = 'AI_ASSISTED',
  DESKTOP = 'DESKTOP',
  VVM = 'VVM',
  SIMPLIFIED = 'SIMPLIFIED',
  COMPLETE = 'COMPLETE',
  ADVANCED = 'ADVANCED',
}

export const convertModality = (modality: Modality): string => {
  let word = '';
  switch (modality) {
    case Modality.SELECT:
      word = 'Selecione uma Opção';
      break;
    case Modality.AVM:
      word = 'AVM';
      break;
    case Modality.AI_ASSISTED:
      word = 'Laudo Assistido por IA';
      break;
    case Modality.DESKTOP:
      word = 'Desktop Valuation';
      break;
    case Modality.VVM:
      word = 'VVM';
      break;
    case Modality.SIMPLIFIED:
      word = 'Laudo Simplificado';
      break;
    case Modality.COMPLETE:
      word = 'Laudo Completo';
      break;
    case Modality.ADVANCED:
      word = 'Laudo Técnico Avançado';
      break;
    default:
      word = '';
  }
  return word;
};

export enum Objective {
  SELECT = 'SELECT',
  SALE = 'SALE',
  RENT = 'RENT',
}

export const convertObjective = (objective: Objective): string => {
  let word = '';
  switch (objective) {
    case Objective.SELECT:
      word = 'Selecione uma Opção';
      break;
    case Objective.SALE:
      word = 'Venda';
      break;
    case Objective.RENT:
      word = 'Locação';
      break;
    default:
      word = '';
  }
  return word;
};

export enum PreFlightPropertyType {
  SELECT = 'SELECT',
  APARTMENT = 'APARTMENT',
  HOUSE = 'HOUSE',
  TOWNHOUSE = 'TOWNHOUSE',
  PENTHOUSE = 'PENTHOUSE',
  STUDIO = 'STUDIO',
  RESIDENTIAL_LAND = 'RESIDENTIAL_LAND',
  URBAN_GLEBE = 'URBAN_GLEBE',
  COMMERCIAL_ROOM = 'COMMERCIAL_ROOM',
  STORE = 'STORE',
  COMMERCIAL_BUILDING = 'COMMERCIAL_BUILDING',
  COMMERCIAL_WAREHOUSE = 'COMMERCIAL_WAREHOUSE',
  COMMERCIAL_LAND = 'COMMERCIAL_LAND',
  LOGISTICS_WAREHOUSE = 'LOGISTICS_WAREHOUSE',
  INDUSTRIAL_BARN = 'INDUSTRIAL_BARN',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
  INDUSTRIAL_PROPERTY = 'INDUSTRIAL_PROPERTY',
  SITE = 'SITE',
  FARMSTEAD = 'FARMSTEAD',
  FARM = 'FARM',
  RURAL_LAND = 'RURAL_LAND',
  RURAL_GLEBE = 'RURAL_GLEBE',
  HOTEL = 'HOTEL',
  HOSPITAL = 'HOSPITAL',
  SCHOOL = 'SCHOOL',
  GAS_STATION = 'GAS_STATION',
  SHOPPING_MALL = 'SHOPPING_MALL',
  MIXED_USE = 'MIXED_USE',
  OTHER = 'OTHER',
}

export const convertPropertyType = (
  propertyType: PreFlightPropertyType
): string => {
  let word = '';
  switch (propertyType) {
    case PreFlightPropertyType.SELECT:
      word = 'Selecione uma Opção';
      break;
    case PreFlightPropertyType.APARTMENT:
      word = 'Apartamento';
      break;
    case PreFlightPropertyType.HOUSE:
      word = 'Casa';
      break;
    case PreFlightPropertyType.TOWNHOUSE:
      word = 'Sobrado';
      break;
    case PreFlightPropertyType.PENTHOUSE:
      word = 'Cobertura';
      break;
    case PreFlightPropertyType.STUDIO:
      word = 'Studio / Kitnet';
      break;
    case PreFlightPropertyType.RESIDENTIAL_LAND:
      word = 'Terreno Residencial';
      break;
    case PreFlightPropertyType.URBAN_GLEBE:
      word = 'Gleba Urbana';
      break;
    case PreFlightPropertyType.COMMERCIAL_ROOM:
      word = 'Sala Comercial';
      break;
    case PreFlightPropertyType.STORE:
      word = 'Loja';
      break;
    case PreFlightPropertyType.COMMERCIAL_BUILDING:
      word = 'Prédio Comercial';
      break;
    case PreFlightPropertyType.COMMERCIAL_WAREHOUSE:
      word = 'Galpão Comercial';
      break;
    case PreFlightPropertyType.COMMERCIAL_LAND:
      word = 'Terreno Comercial';
      break;
    case PreFlightPropertyType.LOGISTICS_WAREHOUSE:
      word = 'Galpão Logístico';
      break;
    case PreFlightPropertyType.INDUSTRIAL_BARN:
      word = 'Barracão Industrial';
      break;
    case PreFlightPropertyType.DISTRIBUTION_CENTER:
      word = 'Centro de Distribuição';
      break;
    case PreFlightPropertyType.INDUSTRIAL_PROPERTY:
      word = 'Imóvel Industrial';
      break;
    case PreFlightPropertyType.SITE:
      word = 'Sítio';
      break;
    case PreFlightPropertyType.FARMSTEAD:
      word = 'Chácara';
      break;
    case PreFlightPropertyType.FARM:
      word = 'Fazenda';
      break;
    case PreFlightPropertyType.RURAL_LAND:
      word = 'Terreno Rural';
      break;
    case PreFlightPropertyType.RURAL_GLEBE:
      word = 'Gleba Rural';
      break;
    case PreFlightPropertyType.HOTEL:
      word = 'Hotel';
      break;
    case PreFlightPropertyType.HOSPITAL:
      word = 'Hospital';
      break;
    case PreFlightPropertyType.SCHOOL:
      word = 'Escola';
      break;
    case PreFlightPropertyType.GAS_STATION:
      word = 'Posto de Combustível';
      break;
    case PreFlightPropertyType.SHOPPING_MALL:
      word = 'Shopping';
      break;
    case PreFlightPropertyType.MIXED_USE:
      word = 'Imóvel Misto';
      break;
    case PreFlightPropertyType.OTHER:
      word = 'Outros';
      break;
    default:
      word = '';
  }
  return word;
};

export enum PreFlightReportFunction {
  SELECT = 'SELECT',
  ACQUISITION = 'ACQUISITION',
  DONATION = 'DONATION',
  ALIENATION = 'ALIENATION',
  DEED_IN_LIEU = 'DEED_IN_LIEU',
  EXCHANGE = 'EXCHANGE',
  GUARANTEE = 'GUARANTEE',
  ACCOUNTING = 'ACCOUNTING',
  INSURANCE = 'INSURANCE',
  AUCTION_BID = 'AUCTION_BID',
  ADJUDICATION = 'ADJUDICATION',
  INDEMNIFICATION = 'INDEMNIFICATION',
  TAXATION = 'TAXATION',
  JUDICIAL = 'JUDICIAL',
  EXTRAJUDICIAL = 'EXTRAJUDICIAL',
  AUCTION = 'AUCTION',
  OTHER = 'OTHER',
}

export const convertPreFlightReportFunction = (
  reportFunction: PreFlightReportFunction
): string => {
  let word = '';
  switch (reportFunction) {
    case PreFlightReportFunction.SELECT:
      word = 'Selecione uma Opção';
      break;
    case PreFlightReportFunction.ACQUISITION:
      word = 'Aquisição';
      break;
    case PreFlightReportFunction.DONATION:
      word = 'Doação';
      break;
    case PreFlightReportFunction.ALIENATION:
      word = 'Alienação';
      break;
    case PreFlightReportFunction.DEED_IN_LIEU:
      word = 'Dação em Pagamento';
      break;
    case PreFlightReportFunction.EXCHANGE:
      word = 'Permuta';
      break;
    case PreFlightReportFunction.GUARANTEE:
      word = 'Garantia';
      break;
    case PreFlightReportFunction.ACCOUNTING:
      word = 'Fins Contábeis';
      break;
    case PreFlightReportFunction.INSURANCE:
      word = 'Seguro';
      break;
    case PreFlightReportFunction.AUCTION_BID:
      word = 'Arrematação';
      break;
    case PreFlightReportFunction.ADJUDICATION:
      word = 'Adjudicação';
      break;
    case PreFlightReportFunction.INDEMNIFICATION:
      word = 'Indenização';
      break;
    case PreFlightReportFunction.TAXATION:
      word = 'Tributação';
      break;
    case PreFlightReportFunction.JUDICIAL:
      word = 'Judicial';
      break;
    case PreFlightReportFunction.EXTRAJUDICIAL:
      word = 'Extrajudicial';
      break;
    case PreFlightReportFunction.AUCTION:
      word = 'Leilão';
      break;
    case PreFlightReportFunction.OTHER:
      word = 'Outros';
      break;
    default:
      word = '';
  }
  return word;
};

export enum PreFlightSource {
  SALES = 'sales',
  RPAM = 'rpam',
}

/**
 * De onde a solicitação veio, para o revisor.
 *
 * POR QUE ISTO PRECISA APARECER NA TELA
 *
 * As duas fontes chegam na mesma fila e são revisadas pela mesma pessoa, mas não são a
 * mesma coisa: a do Laudimob (`sales`) vem de um cliente que contratou pelo site; a do
 * RPAM vem da gestão de carteira da EMGEA, com o ativo já cadastrado do outro lado e um
 * gestor esperando o laudo voltar por integração. Revisar as duas sem saber qual é qual é
 * revisar sem o contexto que decide o que completar antes de aprovar.
 */
export const convertPreFlightSource = (
  source: PreFlightSource | string
): string => {
  switch (source) {
    case PreFlightSource.SALES:
      return 'Laudimob';
    case PreFlightSource.RPAM:
      return 'RPAM / EMGEA';
    default:
      // Fonte nova que o back já aceita e o front ainda não conhece: mostrar o slug cru é
      // melhor que mostrar vazio — diz ao revisor que existe e como se chama.
      return String(source);
  }
};

export enum PreFlightStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum PropertyCategory {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
  INDUSTRIAL = 'INDUSTRIAL',
  RURAL = 'RURAL',
  SPECIAL = 'SPECIAL',
}
